import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useActiveOrg } from "context/ActiveOrgContext";

const CLINICS_PREFIX = "/app/clinics";

/**
 * When the user has no organisations, only `/app/clinics` (and sub-routes) are allowed.
 * Otherwise redirect so they can create or join a clinic.
 */
export function RequireOrganisation({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { loading, organisations } = useActiveOrg();

  const onClinicsRoute =
    pathname === CLINICS_PREFIX || pathname.startsWith(`${CLINICS_PREFIX}/`);

  if (!loading && organisations.length === 0 && !onClinicsRoute) {
    return <Navigate to="/app/clinics" replace />;
  }

  return <>{children}</>;
}
